"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractDefaults = extractDefaults;
const types_1 = require("./types");
const walk_1 = require("./walk");
function extractDefaults(fields) {
    const out = {};
    walk(fields, out);
    return out;
}
function walk(fields, out) {
    for (const node of (0, walk_1.eachLeafField)(fields)) {
        const key = (0, types_1.fieldKeyOf)(node);
        if (key && node.defaultValue !== undefined) {
            out[key] = node.defaultValue;
        }
    }
}
